import { render } from "./log_main.vue?vue&type=template&id=b2a9a6c0"
import script from "./log_main.vue?vue&type=script&lang=js"
export * from "./log_main.vue?vue&type=script&lang=js"

import "./log_main.vue?vue&type=style&index=0&id=b2a9a6c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__